'use client';

import 'setimmediate';
import Transport from 'winston-transport';
import { datadogLogs } from '@datadog/browser-logs';

export class DatadogTransport extends Transport {
  log(info, callback) {
    setImmediate(() => {
      this.emit('logged', info);
    });

    const { level, message, ...meta } = info;

    datadogLogs[String(level).toLowerCase()]?.(message, meta);

    callback();
  }
};
